import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const snackBar = inject(MatSnackBar);
  const router = inject(Router);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      let errorMessage = 'An unexpected error occurred';

      if (typeof ErrorEvent !== 'undefined' && error.error instanceof ErrorEvent) {
        // Client-side error
        errorMessage = `Error: ${error.error.message}`;
      } else {
        // Server-side error
        switch (error.status) {
          case 0:
            errorMessage = 'Unable to connect to server. Please check your network.';
            break;
          case 400:
            errorMessage = error.error?.message || 'Bad Request';
            break;
          case 401:
            errorMessage = 'Session expired. Please login again.';
            localStorage.clear();
            router.navigate(['/login']);
            break;
          case 403:
            errorMessage = 'You are not authorized to perform this action.';
            break;
          case 404:
            errorMessage = 'Requested resource not found. Please contact your administrator';
            break;
          case 500:
            errorMessage =
              'Internal server error. Please try again later. Please contact your administrator';
            break;
          default:
            errorMessage = error.error?.message || `Error Code: ${error.status}`;
            break;
        }
      }

      snackBar.open(errorMessage, '×', {
        panelClass: 'error',
        verticalPosition: 'top',
        duration: 3000,
      });

      return throwError(() => error);
    })
  );
};
